import styled from "styled-components";

const PartnerImgBlockStyles = styled.div`
  .img-block {
    height: 350px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    width: 1000px;
    margin: 0 auto;
    margin-top: 50px;

    &--right {
      flex-direction: row-reverse;
    }

    &--left {
      flex-direction: row;
    }

    &__text-area {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: var(--ts-tan);
      height: 350px;
      width: 500px;
      padding: 60px 40px;
      text-align: left;

      &-tan {
        background: var(--ts-tan) !important;
      }
    }

    &__desc {
      width: 920px;
      margin: 0 auto;

      &-title {
        width: 920px;
        margin: 20px auto 4px;
        font-size: 28px;
        line-height: 36px;
      }
    }

    &__eyebrow {
      color: black;
      font-family: var(--header-font);
      text-transform: uppercase;
      font-size: 20px;
      line-height: 38px;
      margin-bottom: 8px;

      span {
        //hack to apply background color to individual text lines
        box-shadow: 0 0 0 6px var(--neon-yellow);
        background-color: var(--neon-yellow);
        //fix firefox
        box-decoration-break: clone;
        line-height: 30px;
        padding: 0 3px 0 6px;
        border: 1px solid var(--neon-yellow);
      }
    }

    &__header {
      font-family: var(--header-font) !important;
      font-weight: normal !important;
      color: var(--off-black);
      font-size: 28px;
      line-height: 36px;

      &--lower {
        padding-top: 74px;
      }
    }

    &__image {
      width: 500px;
      height: 350px;
    }
  }

  @media only screen and (max-width: 1040px) {
    .img-block {
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: auto;
      width: 600px;

      &--right {
        flex-direction: column;
      }

      &--left {
        flex-direction: column;
      }

      &__text-area {
        width: 100%;
        height: 250px;
        padding: 60px 30px !important;
      }

      &__desc {
        width: 540px;

        &-title {
          width: 540px;
        }
      }

      &__eyebrow {
        width: 100%;
        margin: 0 auto;
        margin-bottom: 8px;

        &--icon {
          height: 18px;
          margin-top: 10px;
        }
      }

      &__header {
        margin: 0 auto;
      }

      &__image {
        width: 100%;
        max-width: 100%;
        height: 400px;
      }
      &__button {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  @media only screen and (max-width: 650px) {
    .img-block {
      width: 100%;

      &__text-area {
        width: 100%;
        padding: 20px 12px !important;
      }

      &__image {
        height: 300px;
      }

      &__eyebrow {
        font-size: 18px;
      }

      &__desc {
        width: 100%;

        &-title {
          width: 100%;
          font-size: 24px;
          line-height: 32px;
        }
      }

      &__header {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }
`;

export default PartnerImgBlockStyles;
